export default {
  styles: {
    global: {
      body: {
        h: "100dvh",
        minH: "100dvh",
        maxH: "100dvh",
      },
      "body.schedule-kiosk": {
        layerStyle: "kioskBody",
        "#root": {
          h: "100dvh",
          w: "full",
          display: "flex",
          flexDirection: "column",
        },
      },
      // react-simple-keyboard
      ".hg-theme-default": {
        backgroundColor: "transparent !important",
        background: "transparent !important",
        ".hg-button[data-skbtn='{//}']": {
          background: "transparent",
          boxShadow: "none",
          border: "none",
          pointerEvents: "none",
        },
      },
    },
  },
};
